import React from 'react';
import { EmptyState } from '@commons/images';
import * as S from './EmptyStateWrapper.style';
export const EmptyStateWrapper = () => (React.createElement(S.EmptyStateWrapper, null,
    React.createElement(S.EmptyStateImg, { loading: "lazy", width: "320", height: "200", src: EmptyState, alt: "Empty state" }),
    React.createElement(S.EmptyStateTitle, null, "Don't know what to search?"),
    React.createElement(S.EmptyStateSubTitle, null, "Here's an offer you can't refuse")));
//# sourceMappingURL=EmptyStateWrapper.js.map